<template>
  <div
    id="CoursePushSetting"
    v-loading="loading"
    class=""
    style="padding: 0 20px"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="是否免费:" :required="true" prop="free">
              <el-radio-group v-model="form.free">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="是否允许分销:" :required="true" prop="retail">
              <el-radio-group v-model="form.retail">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <el-form-item label="是否报名审核:" :required="true" prop="verify">
              <el-radio-group v-model="form.verify">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <div class="grid-content bg-purple">
              <el-form-item
                label="原价(市场价格):"
                :required="true"
                prop="costPrice"
              >
                <el-input v-model="form.costPrice"></el-input>
              </el-form-item>
            </div></div
        ></el-col>
        <el-col :span="12"
          ><div class="grid-content bg-purple">
            <el-form-item label="销售价格:" :required="true" prop="sellPrice">
              <el-input v-model="form.sellPrice"></el-input>
            </el-form-item></div
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="课程有效时间:"
              :required="true"
              prop="validPeriod"
            >
              <el-input
                v-model="form.validPeriod"
                style="width: 70%"
              ></el-input>
              单位天，0为长期有效
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="上架时间:" :required="true" prop="onSale">
              <el-date-picker
                v-model="form.onSale"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="首次开课时间:">
              <el-date-picker
                v-model="form.startTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="下架时间:" :required="true" prop="offSale">
              <el-input v-model="form.offSale" style="width: 65%"></el-input>
              默认为0 ，默认不下架
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item
              label="首次报名截止时间:"
              :required="false"
              prop="endTime"
              label-width="140px"
            >
              <el-date-picker
                v-model="form.endTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="首次截课时间:">
              <el-date-picker
                v-model="form.offClassTime"
                type="datetime"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="是否精选:" :required="false">
              <el-radio-group v-model="form.culling">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="grid-content bg-purple">
            <el-form-item label="精选排序:" :required="false">
              <el-input v-model="form.sort" style="width: 70%"></el-input>
              值越大越靠前
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="学习模式:" :required="false">
              <el-radio-group v-model="form.mode">
                <el-radio :label="0">随机模式</el-radio>
                <el-radio :label="1">顺序模式</el-radio>
              </el-radio-group>
              <span style="margin-left: 30px; color: #ccc"
                >顺序模式下课程无法试听</span
              >
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="grid-content bg-purple">
            <el-form-item label="显示位置:" :required="false">
              <el-radio-group v-model="form.locations">
                <el-radio :label="0">平台与机构</el-radio>
                <el-radio :label="1">平台</el-radio>
                <el-radio :label="2">机构</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <div
            class="grid-content bg-purple"
            style="text-align: center; padding-bottom: 30px"
          >
            <el-button type="primary" @click="nextStep('form')"
              >下一步</el-button
            >
            <el-button type="primary" @click="add('form')">保 存</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/courseware/course'

export default {
  name: 'CoursePushSetting',
  components: {},
  data() {
    return {
      rules: {
        free: [{ required: true, message: '请选择', trigger: 'blur' }],
        retail: [{ required: true, message: '请选择', trigger: 'blur' }],
        verify: [{ required: true, message: '请选择', trigger: 'blur' }],
        costPrice: [{ required: true, message: '请选择', trigger: 'blur' }],
        sellPrice: [{ required: true, message: '请选择', trigger: 'blur' }],
        validPeriod: [{ required: true, message: '请选择', trigger: 'blur' }],
        onSale: [{ required: true, message: '请选择', trigger: 'blur' }],
        offSale: [{ required: true, message: '请选择', trigger: 'blur' }],
        endTime: [{ required: true, message: '请选择', trigger: 'blur' }],
      },
      loading: false,
      form: {
        free: '',
        retail: '',
        verify: '',
        costPrice: '',
        sellPrice: '',
        validPeriod: '',
        onSale: '',
        startTime: '',
        offSale: '',
        endTime: '',
        offClassTime: '',
        culling: '',
        sort: '',
        mode: '',
        locations: '',
      },
      optionstype: ['自学考试', '成人教育', '网络教育', '高端培训'],
      pushOrganList: [
        '华南理工大学1',
        '华南理工大学2',
        '华南理工大学3',
        '华南理工大学4',
      ],
      imageUrl: '',
    }
  },
  methods: {
    // 获取数据
    getList() {
      // this.loading = true
    },

    nextStep(formData) {
      this.$refs[formData].validate((valid) => {
        if (!valid) {
          this.$message.error('请完善信息')
        } else {
          this.$router.push({
            name: 'CourseAdd', //tab所在的页面
            query: {
              tabs: 'third',
              videoTitle: this.$route.query.videoTitle,
              learnTypeId: this.$route.query.learnTypeId,
              courseId: this.$route.query.courseId,
              courseCode: this.$route.query.courseCode,
              ctime: this.$route.query.ctime,
              mhmId: this.$route.query.mhmId,
              uid: this.$route.query.uid,
              giveMhmIds: this.$route.query.giveMhmIds,
              cover: this.$route.query.cover,
              videoBinfo: this.$route.query.videoBinfo,
              videoIntro: this.$route.query.videoIntro,
              isCharge: this.form.free,
              isMount: this.form.retail,
              isVerify: this.form.verify,
              vPrice: this.form.costPrice,
              tPrice: this.form.sellPrice,
              term: this.form.validPeriod,
              listingtime: Math.round(
                new Date(this.form.onSale).getTime() / 1000
              ).toString(),
              uctime: this.form.offSale,
              start: Math.round(
                new Date(this.form.startTime).getTime() / 1000
              ).toString(),
              overTime: Math.round(
                new Date(this.form.endTime).getTime() / 1000
              ).toString(),
              endTime: Math.round(
                new Date(this.form.offClassTime).getTime() / 1000
              ).toString(),
              isBest: this.form.culling,
              bestSort: this.form.sort,
              isOrder: this.form.mode,
              showPlace: this.form.locations,
            },
          })
          this.$router.go(0)
        }
      })
    },

    add(formData) {
      this.$refs[formData].validate((valid) => {
        if (!valid) {
          this.$message.error('请完善信息')
        } else {
          let formdata = new FormData()
          formdata.append('videoTitle', this.$route.query.videoTitle)
          formdata.append('learnTypeId', this.$route.query.learnTypeId)
          formdata.append('courseId', this.$route.query.courseId)
          formdata.append('courseCode', this.$route.query.courseCode)
          formdata.append('ctime', this.$route.query.ctime)
          formdata.append('mhmId', this.$route.query.mhmId)
          formdata.append('uid', this.$route.query.uid)
          formdata.append('giveMhmIds', this.$route.query.giveMhmIds)
          formdata.append('cover', this.$route.query.cover)
          formdata.append('videoBinfo', this.$route.query.videoBinfo)
          formdata.append('videoIntro', this.$route.query.videoIntro)
          formdata.append('isCharge', this.form.free)
          formdata.append('isMount', this.form.retail)
          formdata.append('isVerify', this.form.verify)
          formdata.append('vPrice', this.form.costPrice)
          formdata.append('tPrice', this.form.sellPrice)
          formdata.append('term', this.form.validPeriod)
          formdata.append(
            'listingtime',
            Math.round(new Date(this.form.onSale).getTime() / 1000).toString()
          )
          formdata.append('uctime', this.form.offSale)
          formdata.append(
            'start',
            Math.round(
              new Date(this.form.startTime).getTime() / 1000
            ).toString()
          )
          formdata.append(
            'overTime',
            Math.round(new Date(this.form.endTime).getTime() / 1000).toString()
          )
          formdata.append(
            'endTime',
            Math.round(
              new Date(this.form.offClassTime).getTime() / 1000
            ).toString()
          )
          formdata.append('isBest', this.form.culling)
          formdata.append('bestSort', this.form.sort)
          formdata.append('isOrder', this.form.mode)
          formdata.append('showPlace', this.form.locations)
          api.addCourseDetail(formdata).then(({ data }) => {
            if (data.code == 100000) {
              this.$message({ type: 'success', message: '添加成功' })
            }
          })
        }
      })
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item {
  font-size: 12px;
}
/deep/.el-tabs__item {
  padding: 0 10px !important;
}
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li {
  background-color: #e2e8f4;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #265480;
}
</style>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.ql-editor {
  min-height: 300px;
}
.el-tabs__item {
  font-size: 14px !important;
}
</style>
